// Preserve and override all console methods with a prefix
const prefix = "[RecurringTasks]";
const methods = [
  "log",
  "error",
];

methods.forEach((method) => {
  if (typeof console[method] === "function") {
    const original = console[method];
    console[method] = (...args) => {
      original(prefix, ...args);
    };
  }
});
